import DeviceManager from '../utils/device-manager';
import PureCounter from '../utils/purecounter';

const Footer = {
    init() {
        const that = this;
        this.mobileInitialized = false;
        this.$togglers = document.querySelectorAll('.js-footer-menu-toggler');
        const counter = new PureCounter ();

        /*console.log('registerEventListeners');
        counter.registerEventListeners ();*/

        // Click on submenu toggler
        this.onClickCallback = e => {
            const $toggler = e.target;
            
            $toggler.classList.toggle('closed');
        }

        // Calculate submenu height
        this.calcFooterSubmenuHeight = (attr, $toggler) => {
            const $submenu = $toggler.nextElementSibling;
            const isClosed = $toggler.classList.contains('closed');

            $submenu.classList.add('no-transition');

            $toggler.classList.remove('closed');
            $submenu.style.maxHeight = '';
            $submenu.style.maxHeight = $submenu.clientHeight + 'px';

            if (isClosed) {
                $toggler.classList.add('closed');
            }

            $submenu.classList.remove('no-transition');
        };

        DeviceManager.addCallback(attr => {
            if (!that.mobileInitialized && !DeviceManager.isGreaterThan(attr.current, 'md')) {
                that.enableMobile();
            } else if (that.mobileInitialized && DeviceManager.isGreaterThan(attr.current, 'md')) {
                that.disableMobile();
            }
        });
    },


    enableMobile() {
        this.mobileInitialized = true;

        this.$togglers.forEach(($toggler, index) => {
            $toggler.addEventListener('click', this.onClickCallback);

            DeviceManager.addWindowCallback('calcFooterSubmenuHeight-' + index, this.calcFooterSubmenuHeight, $toggler);
        });
    },

    disableMobile() {
        this.mobileInitialized = false;

        this.$togglers.forEach(($toggler, index) => {
            $toggler.removeEventListener('click', this.onClickCallback);

            DeviceManager.removeWindowCallback('calcFooterSubmenuHeight-' + index);

            $toggler.classList.add('closed');
            $toggler.nextElementSibling.style.maxHeight = '';
        });
    }
}

export default Footer;